import React from 'react';

export const DashboardMainVariationCards = ({
    summary,
    previousSummary,
    variationTickets,
    variationOpen,
    variationClosed,
    formatNumber,
    formatVariation,
    variationClass,
}) => {
    return (
        <div className="row g-3 mb-3">
            <div className="col-12 col-lg-4">
                <div className="card card-body border h-100 dashboard-variation-card">
                    <div className="fs-12 text-muted text-uppercase mb-1">Variación tickets</div>
                    <div className="d-flex align-items-end justify-content-between">
                        <div className="fs-5 fw-bold">{formatNumber(summary?.tickets)}</div>
                        <div className={`fw-semibold ${variationClass(variationTickets)}`}>{formatVariation(variationTickets)}</div>
                    </div>
                    <div className="text-muted fs-11 mt-1">vs período anterior ({formatNumber(previousSummary?.tickets)})</div>
                </div>
            </div>

            <div className="col-12 col-lg-4">
                <div className="card card-body border h-100 dashboard-variation-card">
                    <div className="fs-12 text-muted text-uppercase mb-1">Variación abiertos</div>
                    <div className="d-flex align-items-end justify-content-between">
                        <div className="fs-5 fw-bold">{formatNumber(summary?.openTickets)}</div>
                        <div className={`fw-semibold ${variationClass(variationOpen)}`}>{formatVariation(variationOpen)}</div>
                    </div>
                    <div className="text-muted fs-11 mt-1">vs período anterior ({formatNumber(previousSummary?.openTickets)})</div>
                </div>
            </div>

            <div className="col-12 col-lg-4">
                <div className="card card-body border h-100 dashboard-variation-card">
                    <div className="fs-12 text-muted text-uppercase mb-1">Variación cerrados</div>
                    <div className="d-flex align-items-end justify-content-between">
                        <div className="fs-5 fw-bold">{formatNumber(summary?.closedTickets)}</div>
                        <div className={`fw-semibold ${variationClass(variationClosed)}`}>{formatVariation(variationClosed)}</div>
                    </div>
                    <div className="text-muted fs-11 mt-1">vs período anterior ({formatNumber(previousSummary?.closedTickets)})</div>
                </div>
            </div>
        </div>
    );
};
